<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-parallax :src="TrondStart">
          <v-row align="center" justify="center">
            <div class="d-flex flex-no-wrap justify-space-between">
              <h1>Hi. I'm the developer of PG Box.</h1>
              <v-icon color="primary">fa-smile-wink</v-icon>
            </div>
          </v-row>
          <v-row align="center" justify="center">
            <v-card color="primary" dark elevation="12">
              <div class="d-flex flex-no-wrap justify-space-between">
                <div style="padding: 10px">
                  <v-card-title class="headline">Trond Kjeldsen</v-card-title>
                  <!-- <v-card-subtitle> -->
                  <v-btn light rounded small>
                    <a href="mailto:trond.kjeldsen@gmail.com?subject=PGBox"
                      >Email </a
                    ><v-icon small right>fa-envelope</v-icon></v-btn
                  >

                  <!-- <v-card-subtitle v-text="item.subtitle"></v-card-subtitle> -->
                  <v-btn light rounded small>
                    <a :href="item.flightloglink" target="_blank">
                      Flightlog
                    </a>
                    <v-icon small right>fa-address-card</v-icon>
                  </v-btn>

                  <!-- </v-card-subtitle> -->
                </div>

                <v-avatar class="ma-3" size="90">
                  <v-img :src="Trond"></v-img>
                </v-avatar>
              </div>
            </v-card>
          </v-row>
          <v-row>
            <v-avatar min-width="110px" tile>
              <!-- <v-img
            src="https://cdn.vuetifyjs.com/images/logos/logo.svg"
            alt="Vuetify"
              />-->
              <v-img :src="HlskLogo" alt="HlskLogo"></v-img>
            </v-avatar>
          </v-row>
        </v-parallax>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      item: {
        color: "#952175",
        src: "https://cdn.vuetifyjs.com/images/cards/halcyon.png",
        title: "Trond Kjeldsen",
        subtitle: "Contact info in flightlog:",
        flightloglink: "https://flightlog.org/fl.html?l=1&a=28&user_id=4107",
      },
      TrondStart: require("@/assets/TrondStart.jpg"),
      Logo: require("@/assets/pg_logo_blue.png"),
      // BackGround: require("@/assets/background.png"),
      HlskLogo: require("@/assets/hlsk_logo.png"),
      Trond: require("@/assets/Trond.png"),
    };
  },
};
</script>


